import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CategoriesScreen from './components/CategoriesScreen';
import CategoryScreen from './components/CategoryScreen';
import MaterialScreen from './components/MaterialScreen';
import AdminPanel from './components/AdminPanel';
import { TelegramProvider } from './context/TelegramContext';

function App() {
  useEffect(() => {
    // Инициализация Telegram WebApp
    if (window.Telegram?.WebApp) {
      window.Telegram.WebApp.ready();
      window.Telegram.WebApp.expand();
    }
  }, []);

  return (
    <TelegramProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Routes>
            <Route path="/" element={<CategoriesScreen />} />
            <Route path="/category/:categoryId" element={<CategoryScreen />} />
            <Route path="/material/:materialId" element={<MaterialScreen />} />
            <Route path="/admin" element={<AdminPanel />} />
          </Routes>
        </div>
      </Router>
    </TelegramProvider>
  );
}

export default App; 